


function checkNote()
  {
    if($('textarea#CartDrawer-Note').val() == "")
    {
      $('.cart-drawer__gift').css('color','red');
      $('.cart-drawer__gift').css('border-color','red');

      setTimeout(function(){
      $('.cart-drawer__gift').css('color','currentColor');
      $('.cart-drawer__gift').css('border-color','#e6e6e6');
      },3000);
    }else{
      document.querySelector('button#CartDrawer-Checkout').click();
    }
  }
 

function initSliderToRepeat()
  {
    /*
          var swiperreviews = new Swiper(".allSlidesOfUpsellsCART.swiper", {
      spaceBetween: 15,
      loop: false, 
      slidesPerView: 1.35, 
      autoHeight: true, 
      breakpoints: {
        700: {
          slidesPerView: 1.2, 
        } 
      },
       scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true
      }
        });
    */
    setTimeout(function()
               {
                 

    if(document.querySelector('.upsellsAlltext.CArtUpsellsSlider'))
    {
      
    if(document.querySelector('.upsellsAlltext.CArtUpsellsSlider .scrollItem'))
    {
      document.querySelector('.upsellsAlltext.CArtUpsellsSlider').classList.remove('hideIT')
    }else{
      document.querySelector('.upsellsAlltext.CArtUpsellsSlider').classList.add('hideIT')
    }
    }
                       },1000);
    
  }
initSliderToRepeat();




function upsellItems()
  {
    // if upsells
    var allUpsells = $('input[type=checkbox][name="upsellsCs"]:checked');
    var extraProperties = document.querySelector('#extraProperties');

    var mandatoryUpsells = document.querySelector('.allSlidesOfUpsells.thisUpsellMandatory');
    if(mandatoryUpsells){
      if(!mandatoryUpsells.querySelector('input[name="upsellsCs"]:checked')){
            document.querySelector('.upsellerror').classList.remove("hidden");
            mandatoryUpsells.style.background = "red";
            mandatoryUpsells.scrollIntoView({ block: 'end',  behavior: 'smooth' });
          setTimeout(function(){
            document.querySelector('.upsellerror').classList.add("hidden");
            mandatoryUpsells.style.background = "transparent";
          },4000);
        return;
      }
    }
    
    if(extraProperties){extraProperties.value="";}
        
    var allTitles = '';
    if(allUpsells.length>0)
    {
    var items = [];
    allUpsells.each(function(index){
      var data = {quantity:1,id:parseInt($(this).val())}
      items.push(data); 
    
      allTitles = allTitles.concat(", ", $(this).data('title')); 
    })
    $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {items},
    dataType: 'json', 
    success: function (data) { 
     extraProperties.value=allTitles;
     document.querySelector('button[type="submit"].product-form__submit.thisIsMainButton').click();
     } 
    });   
    }else{
     document.querySelector('button[type="submit"].product-form__submit.thisIsMainButton').click();
    }
  }